var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_svg__Mobile",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.97 59.97"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mobile_svg__cls-1{fill:none;stroke:#0000f0;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mobile_svg__cls-1",
    d: "M26.99 10.99h5.99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "mobile_svg__cls-1",
    d: "M21.14 15H43v35a3 3 0 01-3 3H20a3 3 0 01-3-3V10a3 3 0 013-3h20a3 3 0 013 3v.78",
    transform: "translate(-.02 -.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "mobile_svg__cls-1",
    d: "M17.12 47.97h21.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "mobile_svg__cls-1",
    d: "M35 58.55a29 29 0 10-5 .45",
    transform: "translate(-.02 -.02)"
  })));
}
export default SvgMobile;